import { Component, Output, Input, EventEmitter, AfterViewChecked, ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'conichi-switch',
  templateUrl: './switch.html'
})

export class ConichiSwitchComponent implements AfterViewChecked {
  public switch: boolean;

  @Output() modelChange = new EventEmitter();
  @Input() model: any;
  @Input() on: any;
  @Input() off: any;
  @Input() label: string;

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterViewChecked() {
    if (this.model && this.model === this.on) this.switch = true;
    else if (this.model && this.model === this.off) this.switch = false;

    if (!this.on) this.on = true;
    if (!this.off) this.off = false;
    this.cd.detectChanges();
  }

  emit() {
    this.switch = !this.switch;
    if (this.switch === true) this.modelChange.emit(this.on);    
    if (this.switch === false) this.modelChange.emit(this.off);
  }
}
